import { useEffect, useState } from "react";
import { get, patchRequest } from "../../../http/api";
import PasswordSection from "./PasswordSection";

export default function PrivacySection() {
  const [data, setData] = useState({
    email: "",
    phone: "",
    instagram: "",
    linkedin: "",
    contact_visibility: "after_match"
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  /* FETCH */
  useEffect(() => {
    fetchPrivacy();
  }, []);

  const fetchPrivacy = async () => {
    try {
      const res = await get("profile/privacy");
      setData({ ...data, ...res.data });
    } catch (err) {
      console.error(err);
    }
  };

  /* HANDLE CHANGE */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setSuccess(false);
  };

  /* SAVE */
  const handleSave = async () => {
    setLoading(true);
    try {
      await patchRequest("profile/privacy", data);
      setSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="settings-card">
      <h3>Sécurité & confidentialité</h3>
      <PasswordSection/>
      <p className="settings-hint">
        Tes informations de contact ne sont jamais visibles avant un match
      </p>

      {/* CONTACT INFO */}
      <label>Email de contact</label>
      <input
        name="email"
        value={data.email}
        onChange={handleChange}
        placeholder="email@exemple.com"
      />

      <label>Téléphone</label>
      <input
        name="phone"
        value={data.phone}
        onChange={handleChange}
        placeholder="+212..."
      />

      <label>Instagram (optionnel)</label>
      <input
        name="instagram"
        value={data.instagram}
        onChange={handleChange}
        placeholder="@username"
      />

      <label>LinkedIn (optionnel)</label>
      <input
        name="linkedin"
        value={data.linkedin}
        onChange={handleChange}
        placeholder="linkedin.com/in/..."
      />

      {/* VISIBILITY */}
      <label>Visibilité des contacts</label>
      <select
        name="contact_visibility"
        value={data.contact_visibility}
        onChange={handleChange}
        disabled
      >
        <option value="after_match">
          Visible uniquement après un match
        </option>
      </select>

      <small>
        🔒 Pour ta sécurité, les contacts sont débloqués uniquement après un match accepté
      </small>

      <div className="settings-actions">
        <button
          className="btn primary"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Enregistrement..." : "Enregistrer"}
        </button>

        {success && <span className="success-msg">✔ Sauvegardé</span>}
      </div>
    </section>
  );
}